var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "12px",
    height: "7px",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -1343 -169 )"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6 5.46083470394737  L 11.14892578125 0.0460526315789474  L 11.859375 0.790810032894737  L 6 6.95394736842105  L 0.140625 0.790810032894737  L 0.847412109375 0.0460526315789474  L 6 5.46083470394737  Z ",
    fillRule: "nonzero",
    fill: "#7f7f7f",
    stroke: "none",
    transform: "matrix(1 0 0 1 1343 169 )"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectArrow);
export default __webpack_public_path__ + "static/media/select_arrow.c5932e7bc347015c4a94946a6522c490.svg";
export { ForwardRef as ReactComponent };